// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css, useTheme } from "styled-components";

/* Starter Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
import SizedWrapper, {
    sizedWrapperImageStyles,
    SizedWrapperStyles,
} from "@store/Library/Components/Toolkit/SizedWrapper";
import {
    headerHideForDesktopStyles,
    headerHideForMobileStyles,
    headerMobileSelector,
} from "@store/Themes/common/mixins/header";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import getPreviousBreakpoint from "@toolkit/Framework/Common/Utilities/getPreviousBreakpoint";
import getValuesToBreakpoint from "@toolkit/Framework/Common/Utilities/getValuesToBreakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useHeaderPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";

const zoneWrapperStyles = () => css`
    max-height: inherit;

    > div /* Zone */ {
        max-height: inherit;
    }
`;
/* Starter Custom Code - End */

export interface LogoLinksSearchStyles {
    /* Starter Custom Code - Start */
    sizedWrapper?: SizedWrapperStyles;
    wrapper?: InjectableCss;
    navWrapper?: InjectableCss;
    logoWrapper?: InjectableCss;
    searchWrapper?: InjectableCss;
    contentWrapper?: InjectableCss;
    /* Starter Custom Code - End */
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    sizedWrapper: {
        wrapper: {
            css: css`
                background-color: ${getColor("header")};
                color: ${getColor("header.contrast")};
                transform: translateZ(0);

                ${headerMobileSelector()} {
                    box-shadow: ${x => x.theme.shadows.e60};
                }
            `,
        },
        content: {
            css: siteWidthStyles(),
        },
    },
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-grow: 1;
            max-height: inherit;
            ${x => breakpointValues(x.theme.design.header.itemSpacing, "column-gap")}

            ${({ theme }) => {
                return breakpointValues(
                    getValuesToBreakpoint(
                        theme.design.header.iconButton.padding,
                        getPreviousBreakpoint(theme.design.header.breakpoint, theme),
                        theme,
                    ).map(x => (x ? `-${x}` : x)),
                    ["margin-right", "margin-left"],
                );
            }}
        `,
    },
    navWrapper: {
        css: css`
            ${headerHideForDesktopStyles()}
            ${zoneWrapperStyles()}
            flex-grow: 1;
        `,
    },
    logoWrapper: {
        css: css`
            ${headerHideForMobileStyles()}
            ${zoneWrapperStyles()}
            ${sizedWrapperImageStyles()}
            flex-shrink: 0;
        `,
    },
    searchWrapper: {
        css: css`
            ${headerHideForMobileStyles()}
            ${zoneWrapperStyles()}
            flex-grow: 1;
            max-width: ${pxToRem(810)};
        `,
    },
    contentWrapper: {
        css: css`
            ${zoneWrapperStyles()}
            > div /* Zone */ {
                display: flex;
                align-items: center;
                ${x => breakpointValues(x.theme.design.header.subItemSpacing, "column-gap")}
            }
        `,
    },
};

const styles = logoLinksSearchStyles; // Starter Custom Code

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => {
    /* Starter Custom Code - Start */
    const headerPage = useHeaderPage();
    const theme = useTheme();

    return (
        <SizedWrapper
            heights={theme.design.header.height}
            paddings={theme.design.header.padding}
            extendedStyles={styles.sizedWrapper}
        >
            <StyledWrapper {...styles.wrapper}>
                <StyledWrapper {...styles.navWrapper} data-zone-single>
                    <Zone contentId={headerPage.id || id} zoneName="Nav" />
                </StyledWrapper>
                <StyledWrapper {...styles.logoWrapper} data-zone-single>
                    <Zone contentId={headerPage.id || id} zoneName="Logo" />
                </StyledWrapper>
                <StyledWrapper {...styles.searchWrapper} data-zone-single>
                    <Zone contentId={id} zoneName="Search" />
                </StyledWrapper>
                <StyledWrapper {...styles.contentWrapper}>
                    <Zone contentId={id} zoneName="Content" />
                </StyledWrapper>
            </StyledWrapper>
        </SizedWrapper>
    );
    /* Starter Custom Code - End */
};

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
        allowedContexts: ["Header"], // Starter Custom Code
    },
};

export default logoLinksSearch;
